"use strict";

/**
* Предоставляет инструменты для работы с элементами формы.
*
* @class WebAccess.components.wrappers.form.Form
* @extends BaseObject
* @mixes WebAccess.mixins.requisitesMixin
* @param {object} data - данные формы
* @param {string} serviceUrl - адрес сервиса сохранения данных
* @since 5.2.0.1600
*/

/**
 * Выполняется до начала сохранения формы.
 *
 * @event WebAccess.components.wrappers.form.Form#BeforeSave
 * @param {function} process Основной поток действий по выполнению сохранения формы.
 * При необходимости вызов функции позволяет продолжить процесс сохранения в любой момент времени
 * @param {object} data Данные для сохранения формы
 * @param {function} callback Функция, выполняющаяся после сохранения формы. Можно вызвать в любой момент сохранения
 * @example
 *
 * WA.CR.form.bind("BeforeSave", function(process,data,callback) {
 *   console.log(process,data,callback);
 *   var dialog = new WA.CMP.dialogs.BaseDialog();
 *   dialog.setHtml('Карточка не будет сохранена, но страница перезагрузится');
 *   dialog.ok = function() {
 *     process();
 *   }
 *   dialog.show();
 *   return false;
 * });
 */

/**
 * Выполняется в момент сохранения формы.
 *
 * @event  WebAccess.components.wrappers.form.Form#Save
 * @param {function} process Основной поток действий по выполнению сохранения формы.
 * При необходимости вызов функции позволяет продолжить процесс сохранения в любой момент времени
 * @param {object} data Данные для сохранения формы
 * @param {function} callback Функция, выполняющаяся после сохранения формы. Можно вызвать в любой момент сохранения
 */

/**
 * Выполняется после завершения сохранения формы.
 *
 * @event  WebAccess.components.wrappers.form.Form#AfterSave
 * @param {function} process Основной поток действий по выполнению сохранения формы.
 * При необходимости вызов функции позволяет продолжить процесс сохранения в любой момент времени
 * @param {object} data Данные для сохранения формы
 * @param {function} callback Функция, выполняющаяся после сохранения формы. Можно вызвать в любой момент сохранения
 */

(function (global) {

  var CHANGE_TYPE = {
    REQUISITE_CHANGE: 0,
    DETAIL_ROW_INSERT: 1,
    DETAIL_ROW_DELETE: 2,
    PICK_VALUES_CHANGE: 3,
    FORM_CONTROL_CHANGE: 4,
    FORM_REQUISITE_CONTROL_CHANGE: 5,
    ACTION_CHANGE: 6,
    REQUISITE_GUI_CHANGE: 7
  };

  var CONTROL_TYPE = {
    TABLE: 6,
    REQUISITE: 9,
    INPLACE_HINT: 17,
    TAB: 23,
    HYPERLINK: 26,
    MULTISELECT: 28,
    WEB_BROWSER: 24,
    DETAIL_SECTION_REQUISITE: 100
  };

  var Form = BaseObject.extend([global.mixins.requisitesMixin], {
    serviceUrl: null,
    _current: null,
    _calcServiceCall: {}, //таймауты вызова сервиса на изменение реквизита (для оптимизации количества запросов).

    init: function (data, serviceUrl, opt_current) {
      var me = this;
      log.info('FORM', 'Init current form')

      me.Init = $.Deferred();
      me._reqValuesInit = [];

      me._current = opt_current;
      me._calcServiceCall = {};

      this.serviceUrl = serviceUrl;
      me.requisites = new global.components.wrappers.form.RequisiteCollection();
      if (!data) {
        // Если данных нет, то сразу говорим что форма проинициализирована. Нужно для дальнейшего resolv'a WA.FormInit.
        me.Init.resolve();
        return;
      }
      me._super(data);

      me._data = data;

      me._commandList = [];
      this._isDisabled = me._data.isreadonly;
      me._fillRequisites();

      if (!me._data.isInitialized) {
        me._initRequisiteValues(me._data.req);
      } else {
        me._bindMirrors(me._data.req);
      }
      me._bindCalculation();

      var requisites = me.requisites.toArray();
      requisites.forEach(function (req) {
        req.bind(req['class'].EVENT.CHANGE, function (el, ev, reqData) {
          me.fire(me['class'].EVENT.CHANGE, el, ev, reqData);
        });
      });

      me._current.states.tables.done(function () {
        var form = (!!me._current) ? me._current.form : global.current.form;
        var tables = form.controls.tables;

        _(tables).forEach(function (table) {
          table.bind(table['class'].EVENT.CHANGE, function () {
            me.fire(me['class'].EVENT.CHANGE);
          });
        });
      });

      // _reqValuesInit заполняется в родительском классе requisitesMixin
      $.when.apply(null, me._reqValuesInit).then(function () {
        me.Init.resolve();
        log.info('FORM', 'Current form requsites values inited')
      });
    },
    //---------------------------------------------------------------------//


    className: "Form",

    /**
    * Реквизиты текущей формы.
    * Содержит объекты WebAccess.components.wrappers.form.requisites для управления реквизитами.
    *
    * @namespace WebAccess.current.form.requisites
    * @see WebAccess.components.wrappers.form.requisites
    * @since 5.0.0.7100
    */
    requisites: {},

    /**
    * Команды при сохранении.
    * @private
    * @since 5.0.0.7100
    */
    _commandList: [],

    /**
    * Исходные данные текущей формы
    * @private
    * @since 5.0.0.7100
    */
    _data: null,

    /**
    * Признак активности формы.
    * @private
    * @since 5.0.0.7100
    */
    _isDisabled: false,

    // Событие когда вся форма проинициализирована, т.к. значения всех реквизитов есть.
    Init: null,
    // Массив Init для каждого реквизита в виде Deffered объектов.
    _reqValuesInit: null,
    //---------------------------------------------------------------------//

    /**
    * Создание объектов реквизитов.
    * @method WebAccess.components.wrappers.form.Form#_fillRequisites
    * @since 5.0.0.7100
    * @private
    */
    _fillRequisites: function () {
      for (var reqName in this._data.req) {
        this.requisites.addElement(reqName, this._createRequisite(reqName, this._data.req[reqName]));
      };
      return this;
    },
    //---------------------------------------------------------------------//

    /**
      * Получчение значения реквизита для сериализации.
      * @param {Object} requisite Реквизит, значение которого требуется получить.
      * @param {Object} options Настройки сериализации.
      * @returns {Object} Значение реквизита для сериализации.
      * @since 5.2.0.2006
      * @private
      */
    _getRequisiteValueDependsOnOptions: function (requisite, options) {
      var result;

      if (requisite.getType() == 1 && (options.dateFormat || options.dateTimeFormat)) {
        if (requisite.isShowTime()) {
          result = formatDateTime(requisite.getDate(), options.dateTimeFormat);
        } else {
          result = formatDate(requisite.getDate(), options.dateFormat);
        }
      } else {
        result = requisite.getValue();
      }

      if (!options.onlyValue) {
        result = [result, requisite.getDisplayValue()];
      }

      return result;
    },
    //---------------------------------------------------------------------//

    /**
    * Сериализация формы.
    *
    * @method WebAccess.components.wrappers.form.Form#serialize
    * @ignore
    * @param {Object} opt_options Настройки сериализации.
    * @return {Object} Литеральный объект.
    * @since 5.0.0.7300
    *
    * @example
    * var formBackup = WA.CR.form.serialize();
    * WA.cache.setObject('formBackup', formBackup);
    *
    * ...
    *
    * WA.CR.form.deserialize(WA.cache.getObject('formBackup'));
    */
    serialize: function (opt_options) {
      var options = opt_options || {
        onlyValue: false, // Возвращать только значения, т.е. без отображаемого значения.
        useRowNumber: false, //Возвращать номер строк вместо ИД.
        withoutTables: false, //Не возвращать массив tables.
        dateFormat: '', // Формат дат.
        dateTimeFormat: '', // Формат даты со временем.
        transformMultiReqsToDetailRows: false // Преобразование реквизитов множественного выбора в детальный раздел
      };

      var reqs = this.requisites.toArray();
      var result = {};
      result.details = {};
      result.requisites = {};
      for (var i = 0; i < reqs.length; i++) {
        result.requisites[reqs[i].name] = this._getRequisiteValueDependsOnOptions(reqs[i], options);

        if (options.transformMultiReqsToDetailRows) {
          var reqControl = reqs[i].controls[0];
          if (typeof reqControl !== 'undefined') {
            var refSelectInstance = reqControl.data('ReferenceSelectInstance');
            if ((typeof reqControl.data('ReferenceSelectInstance') !== 'undefined') && reqControl.data('ReferenceSelectInstance').multiselect) {
              //реквизит множественного выбора
              var currentValue = result.requisites[reqs[i].name];
              if ($.isArray(currentValue)) {
                currentValue = currentValue[0];
              }

              if (!!currentValue) {
                var detailNum = refSelectInstance.detailIndex;
                var currentValueArray = currentValue.split(';');
                result.details[detailNum] = {};
                for (var j = 0; j < currentValueArray.length; j++) {
                  var reqInfo = currentValueArray[j].split(':');
                  var multiReqNames = refSelectInstance.referenceCodesAndReqNamesInDetailSection;

                  result.details[detailNum][j] = {};
                  var reqName = multiReqNames[reqInfo[0]].name;
                  if (reqName) {
                    result.details[detailNum][j][reqName] = reqInfo[1];
                  }
                };
              }
            }
          }
        }
      }

      result.tables = {};
      var tables = this.controls.tables;
      for (var table in tables) {
        var detailNum = tables[table].detailNum;
        result.tables[table] = {};
        result.details[detailNum] = {};
        var rows = tables[table].rows.toArray()
        for (var i = 0; i < rows.length; i++) {
          var row = rows[i];
          var rowIdentifier = row.id;
          if (options.useRowNumber) {
            rowIdentifier = row.name; //Номер строки.
          }
          result.tables[table][rowIdentifier] = {};
          result.details[detailNum][rowIdentifier] = {};
          var reqs = row.requisites.toArray();
          for (var k = 0; k < reqs.length; k++) {
            var req = reqs[k];
            var value = this._getRequisiteValueDependsOnOptions(req, options);
            result.tables[table][rowIdentifier][req.name] = value;
            result.details[detailNum][rowIdentifier][req.name] = value;
          }
        }
      }

      if (options.withoutTables) {
        delete result['tables'];
      }

      return result;
    },
    //---------------------------------------------------------------------//

    /**
    * Получить строковое представление объекта.
    *
    * @method WebAccess.components.wrappers.form.Form#asString
    * @return {String} Строковое представление объекта.
    */
    asString: function () {
      return $.toJSON(this.serialize());
    },
    //---------------------------------------------------------------------//

    /**
    * Десериализация формы.
    *
    * @method WebAccess.components.wrappers.form.Form#deserialize
    * @ignore
    * @param {Object} data Сериализованная ранее форма
    * @return  {WebAccess.current.form} Преобразованная форма.
    * @since 5.0.0.7300
    *
    * @example
    * var formBackup = WA.CR.form.serialize();
    * WA.cache.setObject('formBackup', formBackup);
    *
    * ...
    *
    * WA.CR.form.deserialize(WA.cache.getObject('formBackup'));
    */
    deserialize: function (data) {
      var reqs = data.requisites;
      for (var n in reqs) {
        this.requisites[n].setValue(reqs[n][0]).setDisplayValue(reqs[n][1]);
      }

      var tables = data.tables;
      for (var table in tables) {
        for (var rowId in tables[table].rows) {
          for (var req in tables.rows[rowId]) {
            var row = tables[table].rows[rowId];
            this.controls.tables[table].rows[rowId].requisites[req].setValue(row[req][0]).setDisplayValue(row[req][1]);
          }
        }
      }

      return this;
    },
    //---------------------------------------------------------------------//

    /**
     * Восстановить значения реквизитов на форме.
     *
     * @method undoRequisiteChanges
     * @since 5.7.0
     */
    undoRequisiteChanges() {
      // Восстановить значения реквизитов
      const requisites = window.formData.req;
      for (const requisiteName of Object.keys(requisites)) {
        const requisite = this.requisites[ requisiteName ];
        if (requisite.isChanged()) {
          const value = requisites[ requisiteName ].value;
          const displayValue = requisites[ requisiteName ].displayValue;
          requisite.setValue(value, displayValue, false);
          requisite.setUntouched();
        }
      }

      // Восстановить значения табличных разделов
      const tables = this.controls.tables;
      for (const tableName of Object.keys(tables)) {
        const table = tables[ tableName ];
        table.reloadData();
      }
    },

    /**
    * При наличии вычислении на реквизитах обрабатывать их.
    *
    * @method WebAccess.components.wrappers.form.Form#_bindCalcutaion
    * @since 5.2.0.2014
    * @private
    * @return WebAccess.components.wrappers.form.Form
    */
    _bindCalculation() {
      if (!this._current) return;

      const rebindRow = (row) => {
        let rowRequisites = row.requisites.toArray();
        rowRequisites.forEach((rowRequisite) => {
          this._bindRequisiteCalculation(rowRequisite);
        });
      };

      const rebindTable = (table) => {
        let rows = table.rows.toArray();
        rows.forEach((row) => {
          rebindRow(row);
        });
      };

      let requisites = this.requisites.toArray();
      requisites.forEach((cardRequisite) => {
        this._bindRequisiteCalculation(cardRequisite);
      });

      this._current.states.tables.done(() => {
        let tables = this.controls.tables;
        for (let tableName in tables) {
          let table = tables[tableName];

          table.bind(table.class.EVENT.DATA_RELOADED, (table) => {
            rebindTable(table);
          }).bind(table.class.EVENT.ROW_ADDED, (row) => {
            rebindRow(row);
          }).bind('applychanges', (row, changes, table, changedMultiSelects) => {
            if (row) {
              row._locked = true;
            }
            this.applyServerSideChanges(changes, changedMultiSelects);
          });
          rebindTable(table);
        }
      });

      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Если реквизит имеет вычисления, то реализовать их выполенение
    *
    * @method WebAccess.components.wrappers.form.Form#_bindRequisiteCalculation
    * @private
    * @return {boolean} True – форма на странице существует, иначе False.
    * @since 5.0.0.7100
    */
    _bindRequisiteCalculation(req) {
      const parentCurrent = this._current;

      if (req.hasCalculation) {
        req.bind('change', (r, ev, data) => {
          if (req.isCalculationDisabled()) {
            return this;
          }
          req._showSpinner();

          //data может быть массивом, когда заполняется реквизит множественного выбора (#108963).
          if (data instanceof Array) {
            data = {
              value: data
                .map(val => val.value)
                .join(';'),
            };
          }

          clearTimeout(this._calcServiceCall[req.fullName]);
          // Событие change может сработать несколько раз в разнымх местах (в разных компонентах) для одно и того же реквизита. Из-за этого отправятся 2 одинаковых запроса, а нам этого не надо.
          // Например, так бывает autoNumeric тригерит change и slickGrid тригерит change через commitCurrentEdit->fire(requisiteChange). По-другому сделать не получилось.
          this._calcServiceCall[req.fullName] = setTimeout(() => {
            WA.SRV.request(`${this.serviceUrl}/SetRequisiteValue`, {
              Obj: parentCurrent._getObjectLink(),
              RequisiteName: req.fullName,
              RequisiteValue: req.getValue(),
              View: parentCurrent.getReferenceView ? parentCurrent.getReferenceView() : '',
            }, {
              hideError: true,
            }).done((response) => {
              const resp = JSON.parse(response);
              this.applyServerSideChanges(
                resp.Changes,
                resp.ChangedMultiSelectRequisitesValues,
              );
            }).fail((message, response) => {
              const inlineHintParams = {
                priority: INLINE_HINT_PRIORITY.PRIMARY,
                type: Number(response.Severity),
              }; 
              parentCurrent.inlineHint.show(message, inlineHintParams);

              // В ответе с ошибкой могут прийти изменения других реквизитов и их надо будет обработать.
              if (response && response.Result) {
                const result = JSON.parse(response.Result);
                this.applyServerSideChanges(
                  result.Changes,
                  result.ChangedMultiSelectRequisitesValues,
                );
              }
            }).always(function () {
              req._hideSpinner();
            });
          }, 100);

        });
      }
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Обработка изменений пришедших от сервера
    * @param {array} changes набор изменений
    * @method WebAccess.components.wrappers.form.Form#applyServerSideChanges
    * @since 5.2.0.2014
    * @return {WebAccess.components.wrappers.form.Form}
    * @example
    * WA.SRV.call(me.serviceURL + '/ExecuteAction', {
    *  ActionName: name,
    *  ...
    * }, null, null, true).done(function (response) {
    *  var responseAsObject = JSON.parse(response);
    *
    *  // Обрабатываем результат выполнения действия.
    *  var dialogResult = responseAsObject.Result;
    *
    *  // Обрабатываем изменения реквизитов действием.
    *  var changes = responseAsObject.Changes;
    *  console.log(changes);
    *  WA.CR.form.applyServerSideChanges(changes);
    *
    *}).fail(function (err) {
    *  // Показываем ошибку.
    *});
    */
    applyServerSideChanges: function (changes, changedMultiSelects) {
      var me = this;
      if (changes && changes.length) {
        me._applyRequisiteChanges(changes);
        me._applyPickValuesChange(changes);
        me._applySectionsChange(changes);
        me._applyFormControlChanges(changes);
        me._applyActionChanges(changes);
        me._applyRequisiteGuiChange(changes);
      }
      if (changedMultiSelects && Object.keys(changedMultiSelects).length) {
        me._applyMultiSelectRequisiteChanges(changedMultiSelects);
      }

      return me;
    },
    //---------------------------------------------------------------------//

    /**
     * Применить изменения визуальной части реквизитов.
     * @private
     * @param {array} changes Набор изменений.
     * @since 5.5.0.2701
     */
    _applyRequisiteGuiChange: function (changes) {
      var me = this;
      var current = me._current;

      // Получить изменения визуальной части реквизитов.
      var guiChanges = [];
      var details = {};

      _(changes).each(function (change) {
        if (change.Type === CHANGE_TYPE.REQUISITE_GUI_CHANGE) {
          guiChanges.push(change);
          if (change.Section) {
            details[change.Section] = true;
          }
        }
      });

      // Перед тем, как переходить к обработке визуальных изменений,
      // нужно сбросить фокус с активной ячейки грида, иначе невозможно установить
      // значение в данную ячейку и возникают ошибки
      Object.keys(details).forEach(function (sectionNumber) {
        var detail = current.details[sectionNumber];
        var tables = detail.getTables().toArray();
        tables.forEach(function (table) {
          table.resetActiveCell();
        });
      });

      if (me.isChanged() && guiChanges.length) {
        me.save(function () {
          me._applyGuiChangesCallback(guiChanges);
        }, false);
      } else {
        me._applyGuiChangesCallback(guiChanges);
      }
    },

    /**
     * Callback-функция для применения визуальных изменений.
     * @private
     * @param {array} guiChanges Набор изменений.
     * @since 5.5.0.2705
     */
    _applyGuiChangesCallback: function (guiChanges) {
      var me = this;
      var current = me._current;

      _(guiChanges).each(function (change) {
        var requisite;
        var isRequisiteEnabled = change.CanGUIRead && change.CanGUIWrite;

        if (change.Section) {
          var detail = current.details[change.Section];
          if (detail) {
            if (change.RowID) {
              var currentRecord;
              var table = detail.getTable();
              if (table) {
                currentRecord = table.getRowById(change.RowID);
                if (currentRecord) {
                  requisite = currentRecord.requisites[change.Name];
                }
              }
            }

            // Установить CanGUIRead для колонки детального раздела
            var tables = detail.getTables().toArray();
            tables.forEach(function (table) {
              var column = table.columns[change.Name];
              if (column) {
                column.setCanGUIRead(change.CanGUIRead);
                if (isRequisiteEnabled) {
                  column.enable();
                } else {
                  column.disable();
                }
              }
            });

          }
        } else {
          requisite = me.requisites[change.Name];
          if (isRequisiteEnabled) {
            requisite.enable();
          } else {
            requisite.disable();
          }
        }

        if (requisite) {
          // Установка значения реквизита производится только в случае изменения CanGUIRead
          // Как следствие, либо в реквизите, либо в изменении значение должно отображаться
          // как скрытое - в виде *
          if (change.Value === '*' || requisite.getValue() === '*') {
            requisite.setValue(change.Value, change.DisplayValue, false);
            requisite.commit();
          }
        }
      });
    },

    /**
     * Обновляем состояния доступности и видимости кнопок на панели инструментов.
     * @private
     * @param {array} changes Набор изменений.
     * @since 5.5.0.2200
     */
    _applyActionChanges: function (changes) {
      var toolBar = this._current.toolBar;

      if (toolBar) {
        var actionChanges = _(changes).filter(function (change) {
          return change.Type === CHANGE_TYPE.ACTION_CHANGE;
        });

        _(actionChanges).each(function (change) {
          // Получить список связанных с действием кнопок
          var buttons = toolBar.buttons.getButtonsByActionName(change.Name);

          buttons.forEach(function (button) {
            // Установить свойство доступности
            if (change.IsEnabled) {
              button.enable();
            } else {
              button.disable();
            }

            // Установить свойство видимости
            if (change.IsVisible) {
              button.show();
            } else {
              button.hide();
            }

            // Установить свойство отмеченности
            if (change.IsChecked) {
              button.select();
            } else {
              button.unSelect();
            }

            // Установить текст всплывающей подсказки
            button.setHints(change.Hint, change.DisabledHint);
          });
        });
      }
    },
    //---------------------------------------------------------------------//

    /**
     * Обновляем состояния доступности и видимости контролов на форме.
     * @private
     * @param {array} changes набор изменений
     * @since 5.5.0.1302
     */
    _applyFormControlChanges: function (changes) {
      var current = this._current;
      var controlChanges = _(changes).filter(function (change) {
        return change.Type === CHANGE_TYPE.FORM_CONTROL_CHANGE || change.Type === CHANGE_TYPE.FORM_REQUISITE_CONTROL_CHANGE;
      });
      var tabs = current.sideBar.tabs.toArray();

      _(controlChanges).each(function (change) {
        var currentControl;
        var isControlEnabled = change.IsEnabled;
        var color = change.TextColor;
        var backgroundColor = change.BackgroundColor;
        if (change.Type === CHANGE_TYPE.FORM_REQUISITE_CONTROL_CHANGE) {
          isControlEnabled &= !change.IsReadOnly;

          currentControl = current.form.requisites[change.RequisiteName];
          if (currentControl) {
            // Получаем элемент для раскраски по имени контрола, т.к. реквизит может быть привязан к нескольким контролам и изменяем цвет
            const jRequisiteConrol = $(`div[name= ${change.Name}]`);
            let jColoredArea;
            if (currentControl.getType() === REQUISITE_TYPE.REFERENCE || currentControl.getType() === REQUISITE_TYPE.DOCUMENT) {
              jColoredArea = jRequisiteConrol.find('.fakeInput');
              jRequisiteConrol.find('.rs_SelItems input, span').css('color', color);
            } else {
              jColoredArea = jRequisiteConrol.find('input.input[type=text], textarea.input');
              jColoredArea.css('color', color);
            }
            jColoredArea.css('background-color', backgroundColor);            
          } else {
            _(current.form.controls.tables).some(function (table) {
              var columns = table.columns.toArray();
              columns.some(function (column) {
                if (column.dfmName === change.Name) {
                  currentControl = column;
                }
                return currentControl;
              });
              return currentControl;
            });
          }
        } else {
          switch (change.ControlType) {
            case CONTROL_TYPE.TABLE:
              currentControl = current.form.controls.tables[change.Name];
              break;
            case CONTROL_TYPE.TAB:
              var filteredTabs = tabs.filter(function (el) {
                return el.dfmName === change.Name;
              });
              if (filteredTabs.length > 0) {
                currentControl = filteredTabs[0];
                // Закладки боковой панели всегда доступны для перехода. Учитываются только свойства видимости.
                // Сделано по аналогии с десктоп-клиентом, где блокируется не сама вкладка, а ее содержимое.
                isControlEnabled = true;
              }
              break;
            case CONTROL_TYPE.HYPERLINK:
              // Если для метки не указан bind on click, то не делать enable, т.к. он снимает класс disabled.
              currentControl = current.form.controls.links[change.Name];
              if (change.IsEnabled && currentControl._jObject.hasClass('disabled'))
                change.IsEnabled = false;
              break;
            case CONTROL_TYPE.MULTISELECT:
              // Получить имя реквизита
              var reqName = $('div[name=' + change.Name + ']').not('.CardForm_Label').data('requisitename');
              if (reqName) {
                currentControl = current.form.requisites[reqName];
              }
              const jRequisiteConrol = $(`div[name= ${change.Name}]`);               
              jRequisiteConrol.find('.fakeInput').css('background-color', backgroundColor);
              jRequisiteConrol.find('.rs_SelItems input, span').css('color', color);
              break;
            case CONTROL_TYPE.WEB_BROWSER:
              // Если тип контрола - web-браузер, то управляем только видимостью и адресом.                                          
              var currentControl = $('iframe[name=' + change.Name + ']');
              if (currentControl) {
                var url = change.URL;
                currentControl.attr("src", url)
                if (change.IsVisible) {
                  currentControl.show();
                } else {
                  currentControl.hide();
                }
              }
              return;

            case CONTROL_TYPE.INPLACE_HINT:
              // Получить встроенную подсказку              
              let hint = new WA.CMP.NTF.InlineHint();

              if (change.IsVisible) {
                switch (change.Kind) {
                  case MESSAGE_TYPE.ERROR:
                    hint.showError(change.Text, null, INLINE_HINT_PRIORITY.SECONDARY);
                    break;
                  case MESSAGE_TYPE.WARNING:
                    hint.showWarning(change.Text, null, INLINE_HINT_PRIORITY.SECONDARY);
                    break;
                  default:
                    hint.showInfo(change.Text, null, INLINE_HINT_PRIORITY.SECONDARY);
                    break;
                }
              }
              else {
                hint.hide(INLINE_HINT_PRIORITY.SECONDARY);
              }
              return;
            default:
              // Если тип контрола - группа, то управляем только видимостью.
              // Доступность и изменяемость группы перенесена на дочерние элементы.
              currentControl = $('div[name=' + change.Name + ']');
              if (change.IsVisible) {
                currentControl.css('visibility', 'visible');
              } else {
                currentControl.css('visibility', 'hidden');
              }
              return;
          }
        }

        if (currentControl) {
          if (isControlEnabled) {
            currentControl.enable();
          } else {
            currentControl.disable();
          }

          if (change.IsVisible) {
            currentControl.show();
          } else {
            currentControl.hide();
          }

        }
      });
    },
    //---------------------------------------------------------------------//

    /**
     * Обновляем детальные разделы при добавлении/удалении значений
     * @private
     * @since 5.2.0.2014
     */
    _applyRequisiteChanges(changes) {
      let parentCurrent = this._current;

      changes.forEach((currentChange) => {
        if (currentChange.Type === CHANGE_TYPE.REQUISITE_CHANGE) {
          if (currentChange.Section) {
            let currentDetail = parentCurrent.details[currentChange.Section];

            if (currentDetail) {
              let currentDetailTables = currentDetail.getTables().toArray();
              currentDetailTables.forEach((table) => {
                let row = table.rows[currentChange.RowID];

                if (row) {
                  let rowRequisite = row.requisites[currentChange.Name];

                  if (rowRequisite) {
                    rowRequisite.setValue(currentChange.Value, currentChange.DisplayValue, false);
                    rowRequisite.commit();
                  }
                }
              });
            }
          } else {
            let cardRequisite = this.requisites[currentChange.Name];
            if (cardRequisite) {
              cardRequisite.setValue(currentChange.Value, currentChange.DisplayValue, false);
              cardRequisite.commit();
            }
          }
        }
      });
      return this;
    },

    /**
     * Обновить formData на основе значений реквизитов формы.
     *
     * @method _updateFormData
     * @private
     * @since 5.7.0
     */
    _updateFormData() {
      if (window.formData) {
        const requisites = window.formData.req;
        for (const formDataRequisiteName of Object.keys(requisites)) {
          const formRequisite = this.requisites[ formDataRequisiteName ];
          const newDisplayValue = formRequisite.getDisplayValue();
          const newValue = formRequisite.getValue();

          const formDataRequisite = requisites[ formDataRequisiteName ];
          formDataRequisite.displayValue = newDisplayValue;
          formDataRequisite.value = newValue;
        }
      }      
    },

    /**
     * Указать, что реквизиты не изменены.
     *
     * @method _unTouchRequisites
     * @private
     * @since 5.7.0
     */
    _unTouchRequisites() {
      // Главный раздел
      for (const requisite of this.requisites.toArray()) {
        requisite.setUntouched();
      }

      // Детальные разделы
      for (const tableName of Object.keys(this.controls.tables)) {
        const table = this.controls.tables[ tableName ];

        if (table.isChanged()) {
          table.setUntouched();
          for (const row of table.rows.toArray()) {
            if (row.isChanged()) {
              for (const requisite of row.requisites.toArray()) {
                if (requisite.isChanged()) {
                  requisite.setUntouched();
                }
              }
            }
          }
        }
      }
    },

    /**
     * Обновляем значения множественный выборов.
     * @private
     * @since 5.5.0.1000
     */
    _applyMultiSelectRequisiteChanges: function (changedMultiSelects) {
      var me = this;

      if (!changedMultiSelects) return;

      for (reqName in changedMultiSelects) {
        if (me.requisites.isExist(reqName) && me.requisites[reqName].isMultiselect) {
          var req = me.requisites[reqName];
          var displayValues = changedMultiSelects[reqName].First;
          var ids = changedMultiSelects[reqName].Second

          if (req.isMultiselect()) {
            // Множественный выбор из одного или нескольких справочников.

            displayValues = changedMultiSelects[reqName].First.split(';');
            ids = changedMultiSelects[reqName].Second.split(';');

            var values = [];
            ids.forEach(function (id, i) {
              var idParts = id.split(':');

              var refcode;
              if (idParts.length >= 2) {
                refcode = idParts[0];
                id = idParts[1];
              } else {
                var refcodes = req.getReferences();
                // Получаем первый ключ в объекте.
                for (refcode in refcodes) break;
              }

              values.push({
                groupcode: refcode,
                id: id,
                name: displayValues[i]
              });

            });

            req.setValues(values, false);
          } else {
            // Единичный выбор из нескольких справочников.
            req.setValue(ids, displayValues, false);
          }
          req.commit();

        }
      }

    },
    //---------------------------------------------------------------------//

    /**
    * Динамическое перестроение значений pick-реквизита
    * @private
    * @since 5.2.0.2014
    */
    _applyPickValuesChange: function (changes) {
      var me = this;
      var parentCurrent = me._current;


      _(changes).chain().filter(function (req) {
        return req.Type === CHANGE_TYPE.PICK_VALUES_CHANGE;
      }).each(function (req) {

        if (req.Section) {
          //Детальные разделы пропускаем, т.к. некорректно работают из-за режима редактирования и нередактирования.
          return;

          _.each(parentCurrent.details[req.Section].getTables().toArray(), function (table) {

            _.each(table.rows.toArray(), function (row) {

              if (row && row.requisites[req.Name]) {
                var needReset = true;
                var oldVal = row.requisites[req.Name].getValue();

                row.requisites[req.Name].clearValues();
                if (!row.requisites[req.Name].isRequired()) {
                  row.requisites[req.Name].addValue('', '');
                };

                _.each(req.Items, function (item) {
                  if (oldVal == item.ID) needReset = false;
                  row.requisites[req.Name].addValue(item.ID, item.DisplayText);
                });

                if (needReset) {
                  row.requisites[req.Name].setValue('', '', false);
                }
              }
            });
          });
        } else {
          //Реквизиты карточки
          var oldVal = me.requisites[req.Name].getValue();
          var needReset = true;

          me.requisites[req.Name].clearValues();

          if (!me.requisites[req.Name].isRequired()) {
            me.requisites[req.Name].addValue('', '');
          };

          _.each(req.Items, function (item) {
            if (oldVal == item.ID) needReset = false;
            me.requisites[req.Name].addValue(item.ID, item.DisplayText);
          });

          if (needReset) {
            me.requisites[req.Name].setValue('', '', false);
          }
        }
      });
      return me;
    },
    //---------------------------------------------------------------------//

    /**
     * Обновляем детальные разделы при добавлении/удалении значений
     * @private
     * @since 5.2.0.2014
     */
    _applySectionsChange(changes) {

      // Указатель на текущую форму.
      let current = this._current;
      let sectionRowMap = {};

      // Выборка измененных детальных разделов, в которые были добавлены строки.
      changes.forEach((change) => {
        if (change.Type === CHANGE_TYPE.DETAIL_ROW_INSERT || change.Type === CHANGE_TYPE.DETAIL_ROW_DELETE) {          
          let mapRowIdTmp = sectionRowMap[change.Section] || [];
          mapRowIdTmp.push(change.RowID);          
          sectionRowMap[change.Section] = mapRowIdTmp;
        }
      });

      let sections = Object.keys(sectionRowMap);     
      if (!sections.length) return this;

      this.save(() => {
        // Проходим по всему ассоциативному массиву sectionRowMap
        sections.forEach((detailSectionNumber) => {
          // Проверяем наличие детального раздела.
          let detail = current.details[detailSectionNumber];
          if (!detail) return this;

          // Проходим по всем таблицам детального раздела.
          let detailsTablesArray = detail.getTables().toArray();

          detailsTablesArray.forEach((table) => {
            // Вызываем перезагрузку таблицы
            table.reloadData().done(() => {
              // Получаем идентификатор строки по текущему детальному разделу.
              let mapRowIdTmp = sectionRowMap[detailSectionNumber];             
              mapRowIdTmp && mapRowIdTmp.forEach((rowId) => {
                let tableRows = table.rows.toArray();                
                // Находим добавленную строку
                let addedRow = tableRows.find(item => item.id === rowId);
                if (addedRow) {                            
                  table.fire(table['class'].EVENT.ROW_ADDED, table.rows[addedRow.id], table);
                  table.fire(table['class'].EVENT.CHANGE);
                }
              });
            });
          });
        });
      }, false, undefined, {
        disableHidePreviousInlineHint: true
      });
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Проверить наличие формы на странице.
    *
    * @method WebAccess.current.form.isExist
    * @return {boolean} True – форма на странице существует, иначе False.
    * @since 5.0.0.7100
    */
    isExist: function () {
      return !!this._data;
    },
    //---------------------------------------------------------------------//

    /**
    * Признак недоступности реквизитов формы.
    *
    * @method WebAccess.current.form.isDisabled
    * @return {boolean} True – форма открывается только для чтения, иначе False.
    * @since 5.0.0.7100
    */
    isDisabled: function () {
      return this._isDisabled;
    },
    //---------------------------------------------------------------------//

    /**
    * Сделать все реквизиты недоступными и скрыть ссылку «Добавить строку».
    *
    * @method WebAccess.current.form.disable
    * @return {WebAccess.current.form} Текущая форма.
    * @since 5.0.0.7100
    */
    disable: function () {
      var me = this;
      $.when(WA.FormControlsInit, WA.FormInit, WA.DetailsInit).then(function () {
        me._disable();
        if (me.controls)
          for (var tableName in me.controls.tables) {
            me.controls.tables[tableName].disable();
          };
        me._isDisabled = true;
      });
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Сделать все реквизиты доступными и отобразить ссылку «Добавить строку».
    *
    * @method WebAccess.current.form.enable
    * @return {WebAccess.current.form} Текущая форма.
    * @since 5.0.0.7100
    */
    enable: function () {
      var me = this;
      me._enable();
      for (var tableName in me.controls.tables) {
        me.controls.tables[tableName].enable();
      };
      me._isDisabled = false;
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Признак изменения реквизитов.
    *
    * @method WebAccess.current.form.isChanged
    * @return {boolean} True – реквизиты были изменены, иначе False.
    * @since 5.0.0.7100
    */
    isChanged: function () {
      var me = this;
      var reqs = me.requisites.toArray();
      for (var reqI = 0; reqI < reqs.length; reqI++) {
        if (reqs[reqI].isChanged()) {
          return true;
        }
      }
      // Получаем данные из детальных разделов.
      var tables = me.controls.tables;
      for (var tableName in tables) {
        const table = tables[tableName];
        // Проверям саму таблицу, т.к. она могла измениться удалаением строки
        if (table.isChanged()) {
          return true;
        }  
      }
      return false;
    },
    //---------------------------------------------------------------------//


    /**
    * Используется при сохранении формы - обводка реквизитов незаполненных
    * обязательных реквизитов красным.
    * поля для которых доступ только на чтение.
    *
    * @method WebAccess.current.form._highlightRequisites
    * @private
    * @since 5.0.0.7100
    * @return {WebAccess.current.form}
    */
    _highlightRequisites: function (reqsStr, details) {

      var prevColor;
      var me = this;

      if (!reqsStr) return;

      // Получаем список реквизитов
      var reqs = reqsStr.split(", ");
      // Пробегаемся по списку чтобы выделить реквизиты
      for (var i = 0; i < reqs.length; i++) {
        var requisite;
        if (reqs[i].indexOf('$') !== -1) {
          var reqNameParts = reqs[i].split('$');
          var detailNum = +reqNameParts[0];
          var rowId = +reqNameParts[1];
          var reqName = reqNameParts[2];

          var tables = details[detailNum].getTables().toArray();
          for (var t = 0; t < tables.length; t++) {
            var table = tables[t];
            var row = table.rows[rowId];
            if (!row) continue;

            requisite = row.requisites[reqName];
            if (!requisite) continue;

            requisite.highlight();
          }
        } else {
          requisite = me.requisites[reqs[i]];
          if (!requisite) continue;

          requisite.highlight();
        }
      }
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Снятие красной обводки со всех реквизитов.
    *
    * @method WebAccess.current.form._unHighlightRequisites
    * @private
    * @since 5.0.0.7100
    * @return {WebAccess.current.form}
    */
    _unHighlightRequisites: function () {
      $('.Card_Element').find('.Req_Error').removeClass('Req_Error');
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Сохранить карточку объекта.
    *
    * @method WebAccess.current.form.save
    * @param {function} callback Функция, вызвается после сохранения.
    * @param {Boolean} needSaveObject Признак - нужно ли сохранять изменения в базу.
    * @param {Integer} folderIdToPaste Папка для вставки ссылки на сохраняем объект.
    * @param {Object} [options] Дополнительные настройки сохранения.
    * @param {String} options.needShowError Нужно ли показывать ошибку.
    * @param {String} options.disableHidePreviousInlineHint Нужно ли скрывать предыдущую ошибку при удачно сохранении.
    * @return {WebAccess.current.form} Текущая форма карточки объекта с сохраненными изменениями.
    * @since 5.0.0.7100
    */
    save: function (callback, needSaveObject, folderIdToPaste, options) {
      return this.saveAndAttach(callback, needSaveObject, new WA.Link(folderIdToPaste, OBJECT_TYPE.FOLDER), options);
    },
    //---------------------------------------------------------------------//

    /**
    * Сохранить и вложить карточку объекта в папку, задачу, задание или уведомление.
    * @method WebAccess.current.form.saveAndAttach
    * @param {function} callback Функция, вызвается после сохранения.
    * @param {Boolean} needSaveObject Признак - нужно ли сохранять изменения в базу.
    * @param {Object} receiverObjectLink Объект для вставки ссылки на сохраняем объект.
    * @param {Object} [options] Дополнительные настройки сохранения.
    * @param {String} options.needShowError Нужно ли показывать ошибку.
    * @param {String} options.disableHidePreviousInlineHint Нужно ли скрывать предыдущую ошибку при удачно сохранении.
    * @return {WebAccess.current.form} Объект типа form.
    * @since 5.0.0.7100
    */
    saveAndAttach: function (callback, needSaveObject, receiverObjectLink, options) {
      return this._saveExtended(callback, needSaveObject, receiverObjectLink, $.extend({
        needShowError: true
      }, options));
    },
    //---------------------------------------------------------------------//

    /**
    * Расширенное сохранение карточки текущего объекта (больше параметров функции).
    *
    * @method WebAccess.current.form._saveExtended
    * @since 5.1.0.1305
    * @private
    * @return {WebAccess.current.form}
    */
    _saveExtended: function (callback, needSaveObject, receiverObjectLink, options) {
      var me = this;
      me.fire('prepareSave');

      options = options || {};
      // Показываем ошибку по умолчанию?
      options.needShowError = (options.needShowError !== false);
      options.disableHidePreviousInlineHint = (options.disableHidePreviousInlineHint === true);

      me._unHighlightRequisites();

      if (me.isDisabled()) {
        if (callback) callback(false);
        return me;
      };

      needSaveObject = !!needSaveObject;

      var form = (!!me._current) ? me._current.form : global.current.form;
      var data = {
        Obj: $.toJSON(me._data.obj),
        View: WA.CR.getReferenceView(),
        Req: me._getRequisitesToSend(form),
        Cmd: $.toJSON(me._commandList),
        NeedSaveObject: needSaveObject,
        ReceiverObjectLink: receiverObjectLink
      };
      me.fireAll("Save", me._saveData, data, callback, options);

      return me;
    },
    //---------------------------------------------------------------------//

    _getRequisitesToSend: function (form) {
      var res = {};

      // Получаем данные из карточки.
      var reqs = form.requisites.toArray();
      for (var reqI = 0; reqI < reqs.length; reqI++) {
        var req = reqs[reqI];
        if (!req.isCommited() && (req.isChanged() || req.isNew() || (req._data.type === 'pick' && req.isRequired() && req.isRendered()))) {
          res[req.name] = req.getValue();
        };
      };

      // Получаем данные из детальных разделов.
      if (form.controls) {
        var tables = form.controls.tables;
        for (var tableName in tables) {
          var rows = tables[tableName].rows.toArray();
          for (var i = 0; i < rows.length; i++) {
            $.extend(res, rows[i]._getActualValues())
          };
        };
      };
      return $.toJSON(res)
    },
    //---------------------------------------------------------------------//

    /**
    * Отправка сохраняемых данных и применение изменений на клиенте.
    *
    * @method WebAccess.current.form._save
    * @private
    * @since 5.0.0.7100
    * @return {WebAccess.current.form}
    */
    _saveData(data, callback, options) { 
      let params = {
        Obj: data.Obj,
        View: data.View,
        Req: data.Req,
        Cmd: data.Cmd,
        NeedSaveObject: data.NeedSaveObject,
        ReceiverObjectLink: (!!data.ReceiverObjectLink && data.ReceiverObjectLink.id ? data.ReceiverObjectLink.toLinkModel() : null),        
      }
      if (!this._current._jDialog) {
        params.Mode = (new WA.URL()).getParam('mode').toUpperCase()
      }

      WA.SRV.call(this.serviceUrl + '/SaveAndAttach', params, null, null, true).done((result, response) => {        
        if (WA.CMP.NTF.InlineHint && !options.disableHidePreviousInlineHint) {
          WA.CMP.NTF.InlineHint.hideAll();
        }
        this._updateModel(result, this._current.details, data.NeedSaveObject);           
        if (data.NeedSaveObject) {
          UnbindBeforeUnload();
          BindBeforeUnload();     
          this._unTouchRequisites();
        }        
        if (typeof callback === 'function' || callback instanceof Function) {
          callback(true, response.Warning);
        }
        HideTopSpinner();               
      }).fail((message, response) => {        
        this._updateModel(response.Result, global.current.details, data.NeedSaveObject);
        let inlineHint = WA.CR.inlineHint;
        this._handleFailSave(response, options.needShowError, callback, global.current.details, inlineHint);
      });
    },

    /**
    * Обрабатывает неуспешый запрос к веб-методу сохранения карточки.    
    * @method WebAccess.current.form._handleFailSave
    * @param {Object} response Ответ веб-метода.
    * @param {bool} needShowError Признак отображения ошибки: True - если ошибку необходимо отобразить, иначе False.
    * @param {function} callback Функция, которая должна быть вызвана после сохранения.
    * @param {Object} details Детальные разделы.
    * @param {Object} inlineHint Встроенная подсказка.    
    * @private
    * @since 5.5.0    
    */
    _handleFailSave(response, needShowError, callback, details, inlineHint) {      
      const severity = (response.Severity !== "-1" ? Number(response.Severity) : undefined);      
      // Проверяем есть ли в ошибке {}
      if (needShowError) {
        let message;
        const isJSON = new RegExp(/^\{.+\}$/);
        if (isJSON.test(response.Error)) {
          const err = JSON.parse(response.Error);
          // Получаем сообщение без указания реквизитов
          message = format(L("ERROR_MSG"), err.message);
          this._highlightRequisites(err.reqs, details);
        } else {   
          message = format(L("ERROR_MSG"), response.Error);               
        }
        const inlineHintParams = {
          priority: INLINE_HINT_PRIORITY.PRIMARY,
          type: severity,
        }; 
        inlineHint.show(format(L("ERROR_MSG"), message), inlineHintParams);
      };
      if (typeof callback === 'function' || callback instanceof Function) {
        callback(false, response.Warning);
      }
      HideTopSpinner();
    },
    
    /**
    * Устанавливает ИД новым строкам после сохранения.
    * @method WebAccess.current.form._fillRowsID
    * @private
    * @since 5.0.0.7100
    * @return {WebAccess.current.form}
    */
    _fillRowsID(appendedRecords, details) {
      // Заполняем ИД для новых строк.     
      if (appendedRecords) {

        let model = JSON.parse(appendedRecords);
        const rowNumber2IDs = model.RowNumber2ID || [];
        for (const rowNumber of rowNumber2IDs) {
          const tbl = $(`table[data-section=${rowNumber.Section}'][id]`);
          $(`#row${rowNumber.Number}`, tbl).data('id', rowNumber.ID);
        }

        const newRowIDs = model.ApendedRecords || [];
        for (const newRow of newRowIDs) {          
          const section = newRow[0];
          const tempID = newRow[1];
          const realID = newRow[2];
          const tables = details[section].getTables().toArray();

          const table = tables.find((table) => {
            return !!table.rows[tempID];
          });
          table._updateRowID(tempID, realID);

          // Обнуляем признак isNew
          table.rows[realID]._isNew = false;
          const reqs = table.rows[realID].requisites.toArray();
          reqs.forEach((r) => { 
            r._isNew = false; 
          });

          this._commandList = this._commandList.filter((cmd) => {
            return cmd.ID != tempID && cmd.Section != section
          });
        }        
      };             
      return this;
    }, 

    /**
     * Обновляет модель карточки.
     *
     * @method WebAccess.current.form._updateModel
     * @param {string} result Строка, содержащая модели карточки в формате JSON.
     * @param {Object} details Детальные разделы.
     * @param {bool} needApplyChanges Признак необходимости применения изменений: True - если изменения необходимо применить, иначе False.
     * @private
     * @since 5.7.0
     */
    _updateModel(result, details, needApplyChanges) {
      if (result) {
        const model = JSON.parse(result);
        if (!this._current._jDialog) {
          if (needApplyChanges) { 
            // Применяем серверные изменения.
            this.applyServerSideChanges(
                model.Changes,
                model.ChangedMultiSelectRequisitesValues,
              );
                                           
            // Обновление formData на основе изменений реквизитов
            this._updateFormData();          
          }
                  
          // Обновляем тулбар.        
          this._current.initToolbar('ToolbarContainer', model.ToolBarModel);                                     
          
          // Обновляем заголовок страницы.
          const headerDomElement = $('#ctl00_CardHeader_PageHeader').find('.react-container')[0];
          if (headerDomElement) {
            WA.CR.initCardHeader(headerDomElement, model.CardHeader);
          }          
        }
                
        // Заполняем ИД строк в детальных разделах.
        this._fillRowsID(model.AdditionalCardFormResult, details);
      }      
    }
    //---------------------------------------------------------------------//
  }, {
    EVENT: {
      /**
      * Событие срабатывает, если данные на форме были изменены.
      *
      * @event WebAccess.components.wrappers.form.Form.EVENT.CHANGE
      * @param {object} context Ссылка на экземпляр класса
      * @since 5.5.0.2201
      */
      CHANGE: 'change'
      //-------------------------------------------------------------------//
    }
  });

  global.components.wrappers.form.Form = Form;
})(window.WebAccess);
